export const SHERWIN_WILLIAMS_TEXT_ONLY_LOGO =
  'sherwin_williams_text_only_logo.svg'
export const NOT_FOUND_LOGO = 'imageNotFound.png'
export const SHERWIN_WILLIAMS_LOGO = 'clientlogo-alt_5b4e3a29f0a01.png'
export const SHW_PHOTO_IMAGING_LOGO = 'shwphotoImaging_546873545965.png'
